import { Field, Fieldset } from '@oms/ui-field';
import { Radio, RadioGroup } from '@oms/ui-radio';
import { NumberInput } from 'components/NumberInput'; //'@oms/ui-number-input';

import {
  required,
  posNumber,
  lessThanMaxYear,
  composeValidators,
  noDecimals,
  amountMax,
} from '../validate';
import { Stack } from '@oms/ui-stack';
import { Heading } from '@oms/ui-heading';

export const ExchangTradedFunds = () => {
  //Egenkapitalsbevis
  return (
    <Stack gap={2}>
      <Heading>ETF (Exchange Traded Funds)</Heading>
      <Fieldset
        as={RadioGroup}
        name="knowledge.etf.knowledgeLevel"
        legend="Kunnskapsnivå"
        validate={required}
      >
        <Field as={Radio} validate={required} label="Høy" value="HIGH" />
        <Field as={Radio} validate={required} label=" Middels" value="MEDIUM" />
        <Field as={Radio} validate={required} label=" Lav" value="LOW" />
      </Fieldset>

      <Field
        name="knowledge.etf.numberOfTrades"
        as={NumberInput}
        lang="nb"
        inputMode="numeric"
        label="Antall handler siste år"
        validate={composeValidators(noDecimals, required, posNumber, amountMax)}
      />

      <Field
        as={NumberInput}
        lang="nb"
        name="knowledge.etf.yearsExperience"
        label="Antall år(s) erfaring"
        validate={composeValidators(
          noDecimals,
          required,
          lessThanMaxYear,
          posNumber,
        )}
      />
    </Stack>
  );
};

export default ExchangTradedFunds;
